

export enum QuestType{
    single= "single",
    multiple= "multiple",
    text= "text",
}